export default "__VITE_ASSET__D1S5Q4UR__"